// Per-role sub scoping helpers.
// Works on the flattened sub list (with programKode + programNama attached).

import { hasRole } from "./auth";

export function scopeSubsForUser(user, allSubs, assignments) {
  if (!user) return [];
  if (hasRole(user, "IRBAN")) return allSubs;

  return allSubs.filter((s) => {
    const a = assignments[s.id];
    if (!a) return false;
    switch (user.role) {
      case "DALNIS":
        return a.dalnisId === user.id;
      case "KETUA_TIM":
        return a.ketuaId === user.id;
      case "ANGGOTA_TIM":
        return Array.isArray(a.anggotaIds) && a.anggotaIds.includes(user.id);
      default:
        return false;
    }
  });
}

/**
 * People relevant to the current user for workload chart:
 * - ADMIN/IRBAN/DALNIS: semua user kecuali IRBAN
 * - KETUA_TIM: ketua themselves + any anggota on the same subs
 * - ANGGOTA_TIM: just themselves
 *
 * ADMIN sengaja TIDAK dikecualikan dari daftar orang — ia boleh merangkap peran
 * operasional, jadi bebannya ikut dihitung. IRBAN dikecualikan karena ia
 * penerima eskalasi, bukan pelaksana.
 */
export function scopePeopleForUser(user, allUsers, scopedSubs, assignments) {
  if (!user) return [];
  if (hasRole(user, "IRBAN", "DALNIS")) {
    return allUsers.filter((u) => u.role !== "IRBAN");
  }
  if (user.role === "KETUA_TIM") {
    const ids = new Set([user.id]);
    for (const s of scopedSubs) {
      const a = assignments[s.id];
      if (!a) continue;
      (a.anggotaIds || []).forEach((id) => ids.add(id));
    }
    return allUsers.filter((u) => ids.has(u.id));
  }
  // ANGGOTA_TIM
  return allUsers.filter((u) => u.id === user.id);
}

export function labelForRole(role) {
  return {
    ADMIN: "Semua data unit",
    IRBAN: "Semua data unit",
    DALNIS: "Hanya kegiatan di bawah koordinasi Anda",
    KETUA_TIM: "Hanya kegiatan tim Anda",
    ANGGOTA_TIM: "Hanya kegiatan pribadi Anda",
  }[role] || "Data terfilter";
}
